import styled from "styled-components";
import { Box } from "@mui/material";
import FormField from "./FormField";
import { portalColors } from "./BusinessPortalComponents";

export const UserPermissionModalContainer = styled(Box)`
    font-family: Manrope, Helvetica, sans-serif;
    color: ${portalColors.text};
    min-width: 0;
    display: grid;
    box-sizing: border-box;
`;

export const PermissionModalHeading = styled.div`
    font-size: 1.75rem;
    line-height: 1.1;
    font-weight: 800;
    color: ${portalColors.text};
    overflow-wrap: anywhere;
`;

export const PermissionModalSection = styled.div`
    min-width: 0;
    padding: 1rem;
    background: ${portalColors.surface};
    border: 1px solid ${portalColors.border};
    border-radius: 8px;
    box-sizing: border-box;
`;

export const PermissionModalRowLabel = styled.div`
    color: ${portalColors.text};
    font-size: 0.75rem;
    font-weight: 800;
    letter-spacing: 0.1em;
    line-height: 1.25;
    margin: 0 0 0.85rem;
    text-transform: uppercase;
`;

export const PermissionField = styled.div`
    label {
        font-size: 14px;
        font-family: Manrope, Helvetica, sans-serif;
        font-weight: 700;
        margin: 0 0 15px 0;
    }
`;

export const PermissionInput = styled(FormField)`
    border: 1px solid ${portalColors.text};
    border-radius: 12px;
    font-size: 14px;
    margin: 13px 0 0 0;
    padding: 0 0 0 30px;
    text-align: left;
    font-family: Manrope, Helvetica, sans-serif !important;
`;

export const PermissionForm = styled.form`
    position: relative;
`;

export const PermissionModalActionRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    gap: 0.9375rem;
    width: 100%;

    @media (max-width: 600px) {
        margin-right: 0;

        > button {
            max-width: none;
            flex: 1;
        }
    }
`;

export const PermissionScrollGrid = styled.div`
    ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        border-radius: 6px;
        border-right: none;
        border-left: none;
    }

    ::-webkit-scrollbar-thumb {
        background-color: ${portalColors.text};
        border-radius: 6px;
    }

    ::-webkit-scrollbar-track-piece:start {
        background-color: ${portalColors.surfaceTertiary};
        margin-top: 20px;
        border-radius: 6px;
    }

    ::-webkit-scrollbar-track {
        background: transparent;
    }

    ::-webkit-scrollbar-track-piece:end {
        background-color: ${portalColors.surfaceTertiary};
        border-radius: 6px;
    }
`;

export const PermissionFormRow = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 30px;
    margin: 1em 0 1.9em;

    @media (max-width: 760px) {
        grid-template-columns: 1fr;
    }
`;

export const PermissionSelectedRole = styled.div`
    display: flex;
    justify-content: ${p => p.$alignStart ? "flex-start" : "flex-end"};
    margin-top: 3px;
`;

export const PermissionGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(${p => p.columns || 2}, minmax(0, 1fr));
    grid-column-gap: 30px;

    @media (max-width: 760px) {
        grid-template-columns: 1fr;
    }
`;

export const PermissionCheckField = styled.div`
    margin: 0 0 1em ${p => p.depth ? "1.350rem" : "0"};
    display: ${p => p.hidden ? "none" : "block"};
    opacity: ${p => p.disabled ? 0.55 : 1};

    label {
        margin-left: 5px;
        font-size: 14px;
        font-family: Manrope, Helvetica, sans-serif;
        font-weight: 700;
    }
`;

export const PermissionRadioField = styled.div`
    margin: 3px 0;
    position: relative;

    input {
        position: absolute;
        opacity: 0;
        pointer-events: none;
    }

    label {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-height: 2.75rem;
        min-width: 10rem;
        padding: 0.625rem 1rem;
        border: 1px solid ${portalColors.border};
        border-radius: 8px;
        background: ${portalColors.surface};
        color: ${portalColors.text};
        font-size: 14px;
        font-family: Manrope, Helvetica, sans-serif;
        font-weight: 600;
        box-shadow: 0px 3px 6px #00000014;
        box-sizing: border-box;
        cursor: pointer;
    }

    input:checked + label {
        border-color: ${portalColors.text};
        background: ${portalColors.blueSoft};
        box-shadow: inset 0 0 0 1px ${portalColors.text};
        font-weight: 700;
    }

    input:disabled + label {
        cursor: not-allowed;
        opacity: 0.55;
    }
`;

export const PermissionSubText = styled.div`
    font-size: 12px;
    font-family: Manrope, Helvetica, sans-serif;
    color: ${portalColors.mutedText};
    font-weight: 400;
    margin: 0 0 0 1.6rem;
    max-width: 25em;
`;

export const LearnMoreAboutPermissionButton = styled.button`
    padding: 0.6em 1.5em;
    font-size: 14px;
    font-weight: 600;
    border-radius: 10px;
    border: none;
    box-shadow: none;
    background-color: ${portalColors.blue};
    color: var(--calendar-bg, #fff);
    height: 39px;
    cursor: pointer;
    align-self: flex-end;
`;

export const MoreAboutPermissionsModalContainer = styled(Box)`
    font-family: Manrope, Helvetica, sans-serif;
    color: ${portalColors.text};
    min-width: 0;
    display: grid;
    gap: 1rem;
    position: relative;
    box-sizing: border-box;
`;

export const MoreAboutPermissionsHeading = styled.div`
    font-size: 1.75rem;
    line-height: 1.1;
    font-weight: 800;
    text-align: left;
    margin-right: 1rem;
    color: ${portalColors.text};
`;

export const MoreAboutPermissionsContent = styled(PermissionScrollGrid)`
    position: relative;
    overflow-y: auto;
    max-height: min(56vh, 44rem);
    padding-right: 0.5rem;
`;

export const RoleContainer = styled.div`
    margin: 0 0 20px 0;
`;

export const PermissionDescription = styled.div`
    color: ${portalColors.mutedText};
    font-size: 0.9em;
    font-weight: 500;
    line-height: 1.5;
    margin: 1rem 0;
    max-width: 100%;
`;

export const PermissionList = styled.ul`
    padding: 0;
    list-style: none;
    margin: 20px 0;

    li {
        font-size: 0.9em;
    }
`;

export const PermissionListItem = styled.div`
    text-align: left;
    color: ${portalColors.text};
    font-family: Manrope, Helvetica, sans-serif;
    margin: 0 0 0 ${p => p.depth ? "1.5rem" : "0"};
`;

export const ModalSmallHeading = styled.div`
    color: ${portalColors.text};
    font-size: 14px;
    font-family: Manrope, Helvetica, sans-serif;
    font-weight: 700;
    text-align: left;
`;
